import axios from 'axios' //引用axios
import QS from 'qs';
import { getCookie } from './package-cookies' //引用刚才我们创建的util.js文件，并使用getCookie方法
import router from "../src/router/index"


// axios 配置
axios.defaults.timeout = 600000;

if (process.env.NODE_ENV === 'development') {
  if (Globals.VUE_APP_Debug === 'debug') {
    axios.defaults.baseURL = Globals.VUE_APP_LocalRootUrl// process.env.VUE_APP_LocalRootUrl; //本地前后端测试
  }
  if (Globals.VUE_APP_Debug === 'release') {
    axios.defaults.baseURL = '/request';//前端测试，代理远程服务器API
  }
} else {
  axios.defaults.baseURL = Globals.VUE_APP_PublishRootUrl; //发布线上
}

axios.defaults.headers = {
  'Content-Type': 'application/json; charset=utf-8',
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Credentials': true,
  'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
  'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
}

// http request 拦截器，通过这个，我们就可以把Cookie传到后台
axios.interceptors.request.use(
  config => {
    // if (config.url.indexOf('downLoad') > -1 ||
    //   config.url.indexOf('DownLoad') > -1) {
    //   config.responseType = 'blob'  // 服务请求类型
    // }
    const token = localStorage.auth; //获取Cookie
    const vid = getCookie("vid");

    if (Object.prototype.toString.call(config.data) == '[object FormData]') {
      // 不是formdata类型
      config.headers = {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Credentials': true,
        'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
        'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
      }
    }
    // config.data = JSON.stringify(config.data);
    if (token) {
      config.headers.Authorization = "Bearer " + token.substring(1, token.length - 1) //后台接收的参数，后面我们将说明后台如何接收
    }

    if (vid) {
      config.headers.VerifyId = vid;
    }

    return config;
  }, err => {
    return Promise.reject(err);
  }
);


// http response 拦截器
// 响应拦截器
// 响应拦截器
axios.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是2开头的的情况
  // 这里可以跟你们的后台开发人员协商好统一的错误状态码
  // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          localStorage.clear();
          var domain = location.href;
          if (domain.indexOf("testirweb") >= 0 || domain.indexOf("testgdweb") || domain.indexOf("irhelix") >= 0 || domain.indexOf("gdiconn") >= 0) {
            router.push({
              path: '/login',
            });
          }
          else if (domain.indexOf("testcsweb") >= 0 || domain.indexOf("testgdcsweb") >= 0 || domain.indexOf("helix") >= 0 || domain.indexOf("iconn") >= 0) {
            router.push({
              path: '/clientlogin',
            });
          }
          else {
            router.push({
              path: '/login',
            });
          }
          break;

        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          //   Toast({
          //     message: '登录过期，请重新登录',
          //     duration: 1000,
          //     forbidClick: true
          // });
          // // 清除token
          // localStorage.removeItem('token');
          // store.commit('loginSuccess', null);
          // // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          // setTimeout(() => {
          //     router.replace({
          //         path: '/login',
          //         query: {
          //             redirect: router.currentRoute.fullPath
          //         }
          //     });
          // }, 1000);
          //window.alert("没有权限")
          router.push({
            path: '/default/noAccess',
          });
          break;
        // 404请求不存在
        case 404:
          console.log("不存在")
          break;
        // 其他错误，直接抛出错误提示
        default:
          // Toast({
          //     message: error.response.data.message,
          //     duration: 1500,
          //     forbidClick: true
          // });
          console.log(error)

      }
      return Promise.resolve({ code: -1, data: null }); // 返回空数据标记
    }
  });

export default axios;

/**
  * get方法，对应get请求
  * @param {String} url [请求的url地址]
  * @param {Object} params [请求时携带的参数]
  */
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err.data)
    })
  });
}

/**
 * fetch 请求方法
 * @param url
 * @param params
 * @returns {Promise}
 */
export function fetch(url, params = {}) {

  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * post 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, params = {}, time) {
  if (!time) {
    time = axios.defaults.timeout;
  }
  return new Promise((resolve, reject) => {
    axios.post(url, params, { timeout: time })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}

/**
 * patch 方法封装
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err);
      })
  })
}

/**
 * put 方法封装
 * @param url
 * @param data
 * @returns {Promise}
 */
export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err.data);
      })
  })
}


export function axiosDelete(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.delete(url, {
      params: data
    })
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err.data);
      })
  })
}
